import React, { useState } from 'react'
import { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import staticInformationService from '../../../services/Internal/Staff/dashboardInformation.service';
import { Bar } from 'react-chartjs-2';

function TopCards() {
    const push = useNavigate();

    const [individualLicenses, setIndividualLicenses] = useState();
    const [firmLicenses, setFirmLicenses] = useState();
    const [dualLicenseData, setDualLicenseData] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        Promise.all([
            staticInformationService.getDashboardNumbers(),
            staticInformationService.getDashboardDualLicenseCount()
        ]).then((response) => {
            var dashboardNumberResponse = response[0];
            var dualResponse = response[1];
            if (dashboardNumberResponse.data) {
                setIndividualLicenses(dashboardNumberResponse.data.individualLicenses.toLocaleString("en-US"));
                setFirmLicenses(dashboardNumberResponse.data.firmLicenses.toLocaleString("en-US"));
            };
            setDualLicenseData({
                pepls: dualResponse.data[0].dualLicenseCount.toLocaleString("en-US"),
                efvf: dualResponse.data[1].dualLicenseCount.toLocaleString("en-US")
            });
            setHasLoaded(true);
        });
    }, [])

    return (
        hasLoaded &&
        <>
            <Row>
                <Col sm={12} md={4} className="mb-3">
                    <Card id="internalDashboardInvLicensesCard"  >
                        <Card.Header>
                            <h5>
                                Individual Licenses
                            </h5>
                        </Card.Header>
                        <Card.Body>
                            <h1>{individualLicenses}</h1>
                            <b>All Active Licenses</b>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={4} className="mb-3">
                    <Card id="internalDashboardFirmLicensesCard" >
                        <Card.Header>
                            <h5>
                                Firm Licenses
                            </h5>
                        </Card.Header>
                        <Card.Body>
                            <h1>{firmLicenses}</h1>
                            <b>All Active Licenses</b>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={4} className="mb-3">
                    <Card id="internalDualLicenseDashboardCard">
                        <Card.Header>
                            <h5>Dual Licenses
                            </h5>
                        </Card.Header>
                        <Card.Body style={{ padding: '0 1rem' }}>
                            <Row>
                                <Col style={{ borderRight: '1px solid rgba(0, 0, 0, 0.125)' }}>
                                    <Card.Body style={{ padding: '1.25rem .25rem .8rem .25rem' }}>
                                        <h1>{dualLicenseData.pepls}</h1>
                                        <b>PE/PLS</b>
                                    </Card.Body>
                                </Col>
                                <Col>
                                    <Card.Body style={{ padding: '1.25rem .25rem .8rem .25rem' }}>
                                        <h1>{dualLicenseData.efvf}</h1>
                                        <b>EF/VF</b>
                                    </Card.Body>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                {/*<Col >*/}
                {/*    <Card id="internalDashboardAskLolaCard">*/}
                {/*        <Card.Header>*/}
                {/*            <h5>*/}
                {/*                Ask LOLA*/}
                {/*                </h5>*/}
                {/*        </Card.Header>*/}
                {/*        <Card.Body>*/}
                {/*            <h1>{askLola}</h1>*/}
                {/*            <b>Unanswered</b>*/}
                {/*        </Card.Body>*/}
                {/*    </Card>*/}
                {/*</Col>*/}
                {/*<Col>*/}
                {/*    <Card id="internalDashboardCasesCard">*/}
                {/*        <Card.Header>*/}
                {/*            <h5>*/}
                {/*                Cases*/}
                {/*                </h5>*/}
                {/*        </Card.Header>*/}
                {/*        <Card.Body>*/}
                {/*            <h1>{cases}</h1>*/}
                {/*            <b>Open</b>*/}
                {/*        </Card.Body>*/}
                {/*    </Card>*/}
                {/*</Col>*/}
            </Row>
        </>
    )
}

export default TopCards;